import { render, staticRenderFns } from "./ProductInfoDisplay.vue?vue&type=template&id=04f1f75e&scoped=true"
import script from "./ProductInfoDisplay.vue?vue&type=script&lang=js"
export * from "./ProductInfoDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoDisplay.vue?vue&type=style&index=0&id=04f1f75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1f75e",
  null
  
)

export default component.exports